<div class="flex sm:grid grid-cols-12 flex-col gap-x-5 sm:gap-y-5">
  <!-- zipCode -->
  <ui-input-label labelFor="address-zipCode" class="col-span-6">
    {{ 'cockpit.organization.createForm.address.zipCode.label' | transloco }}
    <span class="text-error dark:text-error-darkmode">*</span>
    <ui-input-simple
      type="text"
      [formField]="organizationForm.address.zipCode"
      autocomplete="off"
      inputId="address-zipCode"
    />
    <app-field-errors slot="bottom" [fieldState]="organizationForm.address.zipCode()" />
  </ui-input-label>
  <!-- city -->
  <ui-input-label labelFor="address-city" class="col-span-6">
    {{ 'cockpit.organization.createForm.address.city.label' | transloco }}
    <span class="text-error dark:text-error-darkmode">*</span>
    <ui-input-simple
      type="text"
      [formField]="organizationForm.address.city"
      autocomplete="off"
      inputId="address-city"
    />
    <app-field-errors slot="bottom" [fieldState]="organizationForm.address.city()" />
  </ui-input-label>
  <!-- street -->
  <ui-input-label labelFor="address-street" class="col-span-6">
    {{ 'cockpit.organization.createForm.address.street.label' | transloco }}
    <span class="text-error dark:text-error-darkmode">*</span>
    <ui-input-simple
      type="text"
      [formField]="organizationForm.address.street"
      autocomplete="off"
      inputId="address-street"
    />
    <app-field-errors slot="bottom" [fieldState]="organizationForm.address.street()" />
  </ui-input-label>
  <!-- streetNumber -->
  <ui-input-label labelFor="address-streetNumber" class="col-span-3">
    {{ 'cockpit.organization.createForm.address.streetNumber.label' | transloco }}
    <span class="text-error dark:text-error-darkmode">*</span>
    <ui-input-simple
      type="text"
      [formField]="organizationForm.address.streetNumber"
      autocomplete="off"
      inputId="address-streetNumber"
    />
    <app-field-errors slot="bottom" [fieldState]="organizationForm.address.streetNumber()" />
  </ui-input-label>
  <!-- streetNumberSuffix -->
  <ui-input-label labelFor="address-streetNumberSuffix" class="col-span-3">
    <div class="flex">
      <span class="flex-1">{{
        'cockpit.organization.createForm.address.streetNumberSuffix.label' | transloco
      }}</span>
      <span
        class="text-on-surface-variant dark:text-on-surface-variant-darkmode text-sm font-normal"
      >
        {{ 'validators.optional' | transloco }}
      </span>
    </div>
    <ui-input-simple
      type="text"
      [formField]="organizationForm.address.streetNumberSuffix"
      autocomplete="off"
      inputId="address-streetNumberSuffix"
    />
    <app-field-errors slot="bottom" [fieldState]="organizationForm.address.streetNumberSuffix()" />
  </ui-input-label>

  <!-- hasDifferentBillingAddress -->
  <ui-toggle-label class="col-span-12">
    <ui-toggle [formField]="organizationForm.hasDifferentBillingAddress" />
    {{ 'cockpit.organization.createForm.billingAddress.toggle' | transloco }}
  </ui-toggle-label>
  @if (organizationForm.hasDifferentBillingAddress().value()) {
    <!-- street -->
    <ui-input-label labelFor="billingAddress-street" class="col-span-6">
      {{ 'cockpit.organization.createForm.billingAddress.street.label' | transloco }}
      <span class="text-error dark:text-error-darkmode">*</span>
      <ui-input-simple
        type="text"
        [formField]="organizationForm.billingAddress.street"
        autocomplete="off"
        inputId="billingAddress-street"
      />
      <app-field-errors slot="bottom" [fieldState]="organizationForm.billingAddress.street()" />
    </ui-input-label>
    <!-- streetNumber -->
    <ui-input-label labelFor="billingAddress-streetNumber" class="col-span-3">
      {{ 'cockpit.organization.createForm.billingAddress.streetNumber.label' | transloco }}
      <span class="text-error dark:text-error-darkmode">*</span>
      <ui-input-simple
        type="text"
        [formField]="organizationForm.billingAddress.streetNumber"
        autocomplete="off"
        inputId="billingAddress-streetNumber"
      />
      <app-field-errors
        slot="bottom"
        [fieldState]="organizationForm.billingAddress.streetNumber()"
      />
    </ui-input-label>
    <!-- streetNumberSuffix -->
    <ui-input-label labelFor="billingAddress-streetNumberSuffix" class="col-span-3">
      <div class="flex">
        <span class="flex-1">{{
          'cockpit.organization.createForm.billingAddress.streetNumberSuffix.label' | transloco
        }}</span>
        <span
          class="text-on-surface-variant dark:text-on-surface-variant-darkmode text-sm font-normal"
        >
          {{ 'validators.optional' | transloco }}
        </span>
      </div>
      <ui-input-simple
        type="text"
        [formField]="organizationForm.billingAddress.streetNumberSuffix"
        autocomplete="off"
        inputId="billingAddress-streetNumberSuffix"
      />
      <app-field-errors
        slot="bottom"
        [fieldState]="organizationForm.billingAddress.streetNumberSuffix()"
      />
    </ui-input-label>
    <!-- zipCode -->
    <ui-input-label labelFor="billingAddress-zipCode" class="col-span-6">
      {{ 'cockpit.organization.createForm.billingAddress.zipCode.label' | transloco }}
      <span class="text-error dark:text-error-darkmode">*</span>
      <ui-input-simple
        type="text"
        [formField]="organizationForm.billingAddress.zipCode"
        autocomplete="off"
        inputId="billingAddress-zipCode"
      />
      <app-field-errors slot="bottom" [fieldState]="organizationForm.billingAddress.zipCode()" />
    </ui-input-label>
    <!-- city -->
    <ui-input-label labelFor="billingAddress-city" class="col-span-6">
      {{ 'cockpit.organization.createForm.billingAddress.city.label' | transloco }}
      <span class="text-error dark:text-error-darkmode">*</span>
      <ui-input-simple
        type="text"
        [formField]="organizationForm.billingAddress.city"
        autocomplete="off"
        inputId="billingAddress-city"
      />
      <app-field-errors slot="bottom" [fieldState]="organizationForm.billingAddress.city()" />
    </ui-input-label>
  }
</div>
